module.exports = __webpack_public_path__ + "public/img/ico-overview-autarky.0e860d83.svg";